/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback} from 'react'

import useAllSelectionsField from './useAllSelectionsField.js'

const useFilterBasic = ({allSelectionsId, allSelectionsLabel, isMultiSelect, onChange, options, value}) => {
  const {defaultSelections, hasAllOptionsChecked, onSelectAll} = useAllSelectionsField({
    allSelectionsId,
    allSelectionsLabel,
    onChange,
    value
  })

  const hasAllSelectionsField = Boolean(allSelectionsLabel)

  const getHasAllOptionsChecked = ({selections}) => options.every(({id}) => selections.includes(id))

  const handleSelectItem = useCallback(
    ({id}) => {
      const currentValue = Array.isArray(value) ? value : [value]
      const isPreviouslySelected = currentValue.includes(id)
      if (isMultiSelect) return isPreviouslySelected ? removeCurrentSelectedItem({id}) : setNewSelections({id})
      return onChange(isPreviouslySelected ? defaultSelections : [id])
    },
    [isMultiSelect, onChange, value]
  )

  const setNewSelections = useCallback(
    ({id}) => {
      const currentValue = [...value, id]
      const newSelections = currentValue.filter(id => id !== allSelectionsId)
      const hasAllOptionsChecked = getHasAllOptionsChecked({selections: newSelections})
      allSelectionsLabel && hasAllOptionsChecked ? onChange(defaultSelections) : onChange(newSelections)
    },
    [allSelectionsId, allSelectionsLabel, onChange, value]
  )

  const removeCurrentSelectedItem = useCallback(
    ({id}) => {
      const cleanedCurrentSelections = value.filter(currentSelection => currentSelection !== id)
      const hasSelections = Boolean(cleanedCurrentSelections.length)
      const currentSelections = hasSelections ? cleanedCurrentSelections : defaultSelections
      onChange(currentSelections)
    },
    [onChange, value]
  )
  return {hasAllOptionsChecked, hasAllSelectionsField, onSelectAll, onSelectItem: handleSelectItem}
}

export default useFilterBasic
